module.exports = __webpack_public_path__ + "img/instagramWhite.5d002bba.svg";